<template>
  <div class="space-between-y">
    <event-order-create ref="createOrder" @created="getList"/>
    <el-dialog :modal-append-to-body="true" title="活动素材" :visible.sync="media.dialog" width="850px">
      <event-order-media :id="media.id" v-if="media.dialog"></event-order-media>
    </el-dialog>

    <el-dialog append-to-body title="活动单详情" :visible.sync="detail.dialog" width="800">
      <event-order-detail v-if="detail.dialog" :id="detail.id" @updated="getList"></event-order-detail>
    </el-dialog>

    <el-dialog title="活动单分组" :visible.sync="tag.dialog" width="800">
      <event-order-tag v-if="tag.dialog" :id="tag.id"></event-order-tag>
    </el-dialog>

    <div class="both-sides">
      <div class="space-between-x">
      <input-item width="300" label="输入关键字搜索">
        <el-input clearable v-model="form.key" placeholder="搜索名称/订单号/下单人/活动方/联系电话"></el-input>
      </input-item>
      <input-item width="100" label="订单状态">
        <el-select @change="getList()" clearable v-model="form.status" placeholder="请选择">
          <el-option v-for="(item,index) in option.status" :key="index" :label="item.label"
                     :value="item.value"></el-option>
        </el-select>
      </input-item>
      <input-item width="150" label="执行团队">
        <el-select @change="getList()" filterable clearable v-model="form.team" placeholder="请选择团队">
          <el-option v-for="(item,index) in option.teams" :key="index" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </input-item>
      <input-item>
        <el-button type="primary" @click="getList()">搜索</el-button>
      </input-item>
      </div>
      <el-button type="primary" size="small" icon="el-icon-plus" @click="$refs.createOrder.open()">从流程模版创建订单</el-button>
    </div>


    <el-table v-loading="isLoading" :data="list" border stripe>
      <el-table-column v-if="check" prop="name" label="#" width="50">
        <template v-slot="scope">
          <el-checkbox v-model="scope.row.check" @change="checkChange(scope.row)"></el-checkbox>
        </template>
      </el-table-column>

      <el-table-column width="150" prop="name" label="名称">
        <template v-slot="scope">
          <line-overflow :max-lines="1" :content="scope.row.name"></line-overflow>
          <line-overflow class="info-text" :max-lines="1" :content="scope.row.number"></line-overflow>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="状态">
        <template v-slot="scope">
          <el-tag size="mini" :type="getTagType(scope.row.status)">
            {{ option.status.filter(item => item.value === scope.row.status)[0]?.label }}
          </el-tag>
        </template>
      </el-table-column>

      <el-table-column prop="userName" label="下单人">
        <template v-slot="scope">
          <line-overflow :content="scope.row.userName"></line-overflow>
        </template>
      </el-table-column>
      <el-table-column prop="host" label="活动方">
        <template v-slot="scope">
          <line-overflow :content="scope.row.host"></line-overflow>
        </template>
      </el-table-column>
      <el-table-column prop="dealerNames" label="执行团队">
        <template v-slot="scope">
          <line-overflow :content="scope.row.dealerNames?.replace(/[{}]/g, '')"></line-overflow>
        </template>
      </el-table-column>
      <el-table-column prop="templateName" label="活动类型">
        <template v-slot="scope">
          <line-overflow :content="scope.row.templateName"></line-overflow>
        </template>
      </el-table-column>
      <el-table-column prop="contract" label="客户名称">
        <template v-slot="scope">
          <line-overflow :content="scope.row.contract"></line-overflow>
        </template>
      </el-table-column>
      <el-table-column prop="tags" label="分组信息">
        <template v-slot="scope">
          <div v-if="scope.row.tagNames">
            <tags :max-visible="1"
                  :items="scope.row?.tagNames ? scope.row.tagNames.split(',') : []"></tags>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="contractPhone" label="客户联系电话">
        <template v-slot="scope">
          <line-overflow :content="scope.row.contractPhone"></line-overflow>
        </template>
      </el-table-column>
      <el-table-column prop="eventTime" label="活动时间">
        <template v-slot="scope">
          <line-overflow :content="scope.row.eventTime"></line-overflow>
        </template>
      </el-table-column>
      <el-table-column prop="orderAt" label="下单时间">
        <template v-slot="scope">
          <line-overflow :content="scope.row.orderAt"></line-overflow>
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="操作" width="120" align="center">
        <template v-slot="scope">
          <el-button type="text" size="mini" @click="handlerDetail(scope.row.id)">详情</el-button>
          <el-button type="text" size="mini" @click="handlerMedia(scope.row.id)">素材</el-button>
          <el-button type="text" size="mini" @click="handleTag(scope.row.id)">分组</el-button>
        </template>
      </el-table-column>
    </el-table>

    <pagination v-model="page" @updated="getList()"></pagination>
  </div>
</template>

<script>
import InputItem from "@/components/base/layout/InputItem.vue";
import {user} from "@/api/user";
import Pagination from "@/components/base/layout/Pagination.vue";
import {eventorder} from "@/api/eventorder";
import LineOverflow from "@/components/base/layout/text/LineOverflow.vue";
import EventOrderDetail from "@/components/eventorder/EventOrderDetail.vue";
import QrcodeM from "@/components/eventorder/qrcode/QrcodeM.vue";
import EventOrderTag from "@/components/eventorder/EventOrderTag.vue";
import Tags from "@/components/base/Tags.vue";
import EventOrderMedia from "@/components/eventorder/EventOrderMedia.vue";
import EventOrderCreate from "@/components/eventorder/EventOrderCreate.vue";

export default {
  name: 'EventOrderList',
  components: {EventOrderCreate, EventOrderMedia, Tags, EventOrderTag, QrcodeM, EventOrderDetail, LineOverflow, Pagination, InputItem},

  props: {
    check: {
      type: Boolean,
      default: false
    },
  },

  data() {
    return {
      form: {
        key: "",
        status: "",
        team: "",
      },

      option: {
        status: [
          {label: "已完成", value: "FINISHED"},
          {label: "未完成", value: "UNFINISHED"},
          {label: "已取消", value: "CANCELED"},
        ],
        teams: [],
      },

      list: [],

      page: {
        size: 10,
        current: 1,
        total: 0,
      },

      detail: {
        dialog: false,
        id: null,
      },

      tag: {
        dialog: false,
        id: null,
      },

      isLoading: false,


      media: {
        dialog: false,
        id: null,
      },


    };
  },

  created() {
    user.listAllDealer().then(res => {
      this.option.teams = res.data;
    });
    this.getList();
  },

  methods: {

    handlerMedia(id) {
      this.media.id = id;
      this.media.dialog = true;
    },


    // 映射状态到不同的 tag 样式
    getTagType(status) {
      switch (status) {
        case 'FINISHED':
          return 'success';
        case 'UNFINISHED':
          return 'warning';
        case 'CANCELED':
          return 'danger';
        default:
          return 'info';
      }
    },

    handleTag(id) {
      this.tag.id = id;
      this.tag.dialog = true;
    },


    handlerDetail(id) {
      this.detail.id = id;
      this.detail.dialog = true;
    },

    checkChange(order) {
      // 传递选中的订单ID给父组件
      this.$emit('order-selected', order.id);
      this.list.forEach(item => item.check = false);
      order.check = true; // 选中当前项
    },

    getList() {
      this.isLoading = true;
      eventorder.list(this.page.size, this.page.current, this.form.key, this.form.status, this.form.team).then(res => {
        let page = res.data;
        this.list = page?.list.map(item => ({...item, check: false}));
        this.page.total = page?.total;
      }).finally(() => {
        this.isLoading = false;
      })
    },
  },


};
</script>

<style scoped>
</style>
